export default __webpack_public_path__ + "static/media/Header@2x.e441c177.png";